<video #target
       class="video-js" width="100%" (error)="errorHandler($event)"
       controls muted playsinline preload="none">
</video>
